var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.titulo } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isVerDetalle,
                                  expression: "!isVerDetalle"
                                }
                              ],
                              attrs: { row: "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { x6: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "numeric|max_value:200|min_value:0|integer",
                                        expression:
                                          "'numeric|max_value:200|min_value:0|integer'"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      label: _vm.formFields.vmaxima.label,
                                      "data-vv-name": _vm.formFields.vmaxima.id,
                                      id: _vm.formFields.vmaxima.id,
                                      counter: "50",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.vmaxima.id
                                      )
                                    },
                                    model: {
                                      value: _vm.formFields.vmaxima.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.vmaxima,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.vmaxima.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }